import type { ReactNode } from 'react';

interface FeatureCardProps {
  icon: ReactNode;
  heading: string;
  description: string;
}

export function FeatureCard({ icon, heading, description }: FeatureCardProps) {
  return (
    <div
      className="feature-card"
      style={{
        backgroundColor: '#ffffff',
        border: '1px solid #e5e7eb',
        borderRadius: 'var(--radius)',
        padding: 'var(--spacing-lg)',
        transition: 'box-shadow 200ms ease, border-color 200ms ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.06)';
        e.currentTarget.style.borderColor = 'rgba(168,85,247,0.25)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = 'none';
        e.currentTarget.style.borderColor = '#e5e7eb';
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          backgroundColor: 'rgba(168,85,247,0.10)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#A855F7',
        }}
      >
        {icon}
      </div>
      <h3
        style={{
          fontSize: '18px',
          fontWeight: 600,
          color: '#111827',
          marginTop: 'var(--spacing-md)',
          lineHeight: 1.2,
        }}
      >
        {heading}
      </h3>
      <p
        style={{
          fontSize: '16px',
          fontWeight: 400,
          color: '#6b7280',
          marginTop: 'var(--spacing-sm)',
          lineHeight: 1.5,
        }}
      >
        {description}
      </p>
    </div>
  );
}
